import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import Button from 'componentsV2/Button';
import style from './ActionButtons.module.scss';

const ActionButtons = ({ buttons = [], theme = {}, children, isReversed = false }) => {
  if (buttons.length < 1) return null;
  return (
    <div className={classNames([style.buttonContainer, theme.buttonContainer])}>
      {isReversed ? children : null}
      {buttons.map(button => (
        <Button
          {...button}
          theme={{ ...style, ...theme }}
          key={button.label}
          onClick={event => {
            event.preventDefault();
            event.stopPropagation();
            button.onClick();
          }}
        />
      ))}
      {!isReversed ? children : null}
    </div>
  );
};

ActionButtons.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      onClick: PropTypes.func,
      primary: PropTypes.bool,
      type: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
  isReversed: PropTypes.bool,
  theme: PropTypes.shape({}),
  children: PropTypes.node,
};

export default ActionButtons;
